<template>
    <div>
        <AddressListItem
                v-for="(address, k) in addressList"
                :address="address"
                :key="k"
                @onDeleteAddress="onDeleteAddress($event)"
                @onEditAddress="onEditAddress($event)"
        ></AddressListItem>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import AddressListItem from "./AddressListItem.vue";
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

export default {
    name: "AddressList",
    mixins: [ErrorApiMixin],
    components: {
        AddressListItem,
    },
    data: function() {
        return {
            addressList: [],
        };
    },
    mounted: function() {
        this.getAddressList();
    },
    methods: {
        getAddressList: function() {
            var token = Account.getToken();
            BzbsAddressList.apiGetAddressList(token).subscribe((addressList) => {
                this.addressList = addressList;
            }, (err) => {
                this.errorApi(err);
            });
        },

        onDeleteAddress: function(address) {
            this.$emit('onDeleteAddress', address);
        },
        onEditAddress: function(address) {
            this.$emit('onEditAddress', address);
        },
    },
}
</script>
